export const COLOR_SCHEMES = {
    black: {
        bg: 'bg-black',
        headline: 'stokkeCore.white',
        subline: 'stokkeFunctional.alertOrange',
        text: 'stokkeGray.mid'
    }
}
export const PLACEMENT_MAP = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
    left: 'flex-start',
    right: 'flex-end'
}
